import { render, staticRenderFns } from "./WechatWithdrawal.vue?vue&type=template&id=6c650e82&scoped=true"
import script from "./WechatWithdrawal.vue?vue&type=script&lang=js"
export * from "./WechatWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./WechatWithdrawal.vue?vue&type=style&index=0&id=6c650e82&prod&scoped=scoped&lang=stylus"
import style1 from "./WechatWithdrawal.vue?vue&type=style&index=1&id=6c650e82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c650e82",
  null
  
)

export default component.exports